// Reduce motion (lead decision L16, the M7 × M10 contract; UX §5 "Reduce-motion (RM) rules", §7 Motion): the
// EFFECTIVE flag — Settings "Reduce motion" System / On / Off, where System follows prefers-reduced-motion.
// The UI shell (M7 Settings) sets it; the FX layer (M10) reads it when an effect starts (no squash / tilt /
// shake, flashes ≤ 0.3 alpha, fewer particles, coin flights replaced by a HUD tick + one floater).
let reduced = false;

/** True while reduced motion is in effect. */
export function reduceMotion(): boolean {
  return reduced;
}

/** Sets the effective flag (the Settings screen and the OS media query, via the UI shell). */
export function setReduceMotion(v: boolean): void {
  reduced = v;
}
